// Wrapper de la zona autenticada: sidebar fijo + header arriba + outlet del router.

import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/organisms/Sidebar';
import styles from './AppLayout.module.scss';

export function AppLayout() {
  return (
    <div className={styles.shell}>
      <Sidebar />
      <div className={styles.main}>
        <Outlet />
      </div>
    </div>
  );
}
